// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../types';
import ListContainer from '../../../../list';
import ListItem from '../../../../list/components/listItem/styled';

export type { ListItem } from '../../../../list';

export default styled<typeof ListContainer, Theme, _>(ListContainer)`
  padding-bottom: 2rem;
  padding-top: 1rem;

  ${/* sc-selector */ListItem} {
    font-size: .875rem;
  }
`;
